import { Directive, Output, Input, EventEmitter, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appDragDrop]'
})
export class DragDropDirective {

  @Output() onFileDropped = new EventEmitter<any>();

  @HostBinding('style.background-color') private background = '#f5fcff';
  @HostBinding('style.opacity') private opacity = '1';
  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    this.onDragActions(evt,'#9ecbec','0.8');
  }
  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    this.onDragActions(evt,'#f5fcff','1');
  }
  onDragActions(evt :any,background :string,opacity :string){
    evt.preventDefault();
    evt.stopPropagation();
    this.background = background;
    this.opacity = opacity;
  }
  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#f5fcff';
    this.opacity = '1';
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.onFileDropped.emit(files);
    }

  }

}
